<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: ["title", "data", "labels"],
  data() {
    return {
      color: [
        "#FF0000",
        "#FF7F50",
        "#FFA500",
        "#FFFF00",
        "#90EE90",
        "#66CDAA",
        "#00FFFF",
        "#87CEEB",
        "#4169E1",
        "#0000FF",
      ],
    };
  },
  mounted() {
    this.load();
  },
  watch: {
    data() {
      this.load();
    },
  },
  methods: {
    load() {
      this.renderChart(
        {
          labels: this.$props.labels,
          datasets: [
            {
              label: this.$props.title,
              barThickness: 40,
              backgroundColor: "#5E83BA",
              data: this.$props.data,
              datalabels: {
                display: false,
              },
            },
          ],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            mode: "index",
            intersect: false,
          },
          // legend: {
          //   display: false,
          // },
        }
      );
    },
  },
};
</script>
